<template>
    <ul
        class="base-list"
        :class="{
            'base-list--grid': variant === 'grid',
            'base-list--list': variant === 'list'
        }"
    >
        <li
            v-for="(item, index) in items"
            :key="index"
            class="base-list__item"
        >
            <div
                class="base-list__icon"
            >    
                <BaseIcon
                    v-if="item.icon"
                    :icon="item.icon"
                    class="base-list__icon"
                />
            </div>
            
            <div class="base-list__title">
                {{ item.title }}
            </div>
        </li>

        <li
            v-if="!!$slots.default"
            class="base-list__item"
        >
            <slot />
        </li>
    </ul>
</template>

<script setup lang="ts">
type Item = {
    icon?: string;
    title: string;
}
type Props = {
    items: Item[],
    variant?: 'grid' | 'list';
}

defineProps<Props>();
</script>

<style src="./BaseIconList.less" lang="less" />
